import './Button.css'
import type { IconType } from "react-icons";
interface ButtonProps {
  url?: string;
  text: string;
  Icon?: IconType;
  onClick?: () => void;
  size?: "normal" | "small" | null;
}


const Button: React.FC<ButtonProps> = ({ url, text, Icon, onClick, size = "normal"  }) => {

  const buttonClass = `button ${size === "small" ? "button--small" : ""}`;
  if (onClick) {
    return (
      <button className={buttonClass} onClick={onClick}>
        {Icon && <Icon />} {text}
      </button>
    );
  }

  return (
    <a 
      className="button"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {Icon && <Icon />} {text}
    </a>
  );
};

export default Button;
